<template>
    <div class="mainPage">
        <div class="welcomeBlock">
            <div class="welcomeBlock__history"></div>
            <div class="welcomeBlock__textBlock">
                <div class="welcomeBlock__textBlock__title">
                    Бесплатные тренировки
                </div>
                <div class="welcomeBlock__textBlock__text">
                    Выбирайте спортивное сообщество<br />и присоединяйтесь к тренировкам
                </div>
            </div>

            <div v-if="!$store.state.userIsAuthorized" @click="$router.push('/reg')"
                class="welcomeBlock__content__btnReg primary-button">
                Зарегистрироваться
            </div>

            <div v-if="$store.state.userIsAuthorized" @click="$router.push('/eventCalendar')"
                class="welcomeBlock__content__btnReg primary-button">
                Выбрать тренировку
            </div>

            <div class="welcomeBlock__attribute">
                Изображение от Freepik
            </div>
        </div>

        <div class="mainPage__content">
            <div class="contentBlock" ref="map">
                <div class="contentBlock__title">
                    Карта мер<span class="contentBlock__title__emoji">🏐</span>приятий
                </div>

                <div class="mainPage__content__contentBlock__map">
                    <Map></Map>
                </div>
            </div>

            <CaptureButton title="Для тех, кто любит спорт"
                :text="createNoWrapSpecialWords('Выбирайте тренировку на любой вкус, оставайтесь всегда в тонусе.')" buttonText="Перейти в календарь"
                buttonLink="/eventCalendar" />

            <div class="contentBlock">
                <div class="contentBlock__title">
                    Со<span class="contentBlock__title__emoji">🏀</span>бщества
                </div>

                <SocietiesCarousel :data="societies" class="desktop" />
                <SocietiesCarouselMobile :data="societies" class="tablet" />
                <SocietiesCarouselMobile :data="societies" class="mobile" />

                <div class="physicalSportsStreets desktop">
                    <div class="physicalSportsStreets__top">
                        <img src="/img/default/lobachevsky.svg" alt="">

                        <p class="physicalSportsStreets__top__text">Улицы студенческого спорта</p>
                    </div>

                    <routerLink :to="{ path: '/communitiesPage', hash: `/slide6` }" class="physicalSportsStreets__bottom secondary-button">Подробнее</routerLink>
                </div>
            </div>

            <div class="contentBlock">
                <div class="mainPage__content__contentBlock__curency">
                    <div class="mainPage__content__contentBlock__curency__leftBlock">
                        <div class="mainPage__content__contentBlock__curency__leftBlock__content">
                            <div class="mainPage__content__contentBlock__curency__leftBlock__content__title">
                                Больше тренировок–<br />больше призов
                            </div>

                            <div @click="$router.push('/prizesPage')"
                                class="mainPage__content__contentBlock__curency__leftBlock__content__btn secondary-button">
                                Узнать больше
                            </div>
                        </div>

                        <div class="mainPage__content__contentBlock__curency__leftBlock__things">
                            <img src="/img/mainPage/shoper.png" alt="">
                            <img src="/img/mainPage/Bag.png" alt="">
                            <img src="/img/mainPage/shoper.png" alt="">
                            <img src="/img/mainPage/Bag.png" alt="">
                            <!-- <img src="/img/mainPage/bananka.png" alt=""> -->
                            <!-- <img src="/img/mainPage/T-Shirt.png" alt=""> -->
                            <!-- <img src="/img/mainPage/bananka.png" alt=""> -->
                        </div>
                    </div>

                    <div class="mainPage__content__contentBlock__curency__textBlock">
                        <p class="mainPage__content__contentBlock__curency__textBlock__first">
                            {{ createNoWrapSpecialWords("Приходите на бесплатные уличные тренировки и получайте призы.") }}
                        </p>
                        <p class="mainPage__content__contentBlock__curency__textBlock__second">
                            1 тренировка = 1 балл
                        </p>
                        <p class="mainPage__content__contentBlock__curency__textBlock__third">
                            {{ createNoWrapSpecialWords("Баллы вы можете потратить на брендированные вещи программы: баф, шопер или рюкзак. Соберите всю коллекцию «Спорт в каждый двор»!") }}
                        </p>
                    </div>
                </div>
            </div>

            <!-- <div class="contentBlock">
                <div class="contentBlock__title">
                    В п<span class="contentBlock__title__emoji">🏐</span>исках тренеров
                </div>

                <div class="mainPage__content__contentBlock__trainers">
                    <div class="mainPage__content__contentBlock__trainers__left">
                        <div class="mainPage__content__contentBlock__trainers__left__title">
                            Я не тренер,<br />но хочу им стать
                        </div>

                        <div class="flexContainer">
                            <div @click="$router.push('/becomeCoach')"
                                class="mainPage__content__contentBlock__trainers__left__btn secondary-button">
                                Узнать больше
                            </div>
    
                            <div class="mainPage__content__contentBlock__trainers__left__attribute">
                                Изображение от Freepik
                            </div>
                        </div>
                    </div>

                    <div class="mainPage__content__contentBlock__trainers__right">
                        <div class="mainPage__content__contentBlock__trainers__right__title">
                            Я тренер и хочу<br />к вам присоединиться
                        </div>

                        <div class="flexContainer">
                            <a href="https://opros.acgnn.ru/execForm?form_uuid=e667fd16-b020-4bce-a0da-9a959def9c83"
                                target="_blank">
                                <div class="mainPage__content__contentBlock__trainers__right__btn secondary-button">
                                    Заполнить анкету
                                </div>
                            </a>
    
                            <div class="mainPage__content__contentBlock__trainers__right__attribute">
                                Изображение от Freepik
                            </div>
                        </div>
                    </div>
                </div>
            </div> -->

            <!-- <div class="contentBlock">
                <div class="contentBlock__title">
                    <span class="contentBlock__title__emoji big">🏀</span>тзывы
                </div>

                <VideoCarousel :linksList="linksList" class="desktop" />
                <VideoCarouselMobile :linksList="linksList" class="mobile" />
            </div> -->

            <CaptureButton class="freeWorkouts" title="Бесплатные тренировки"
                :text="createNoWrapSpecialWords('Выбирайте спортивное сообщество и присоединяйтесь к тренировкам.')" buttonText="Выбрать тренировку"
                buttonLink="/eventCalendar" withEmoji="true" />
        </div>
    </div>
    <!-- <installPwa /> -->
</template>

<style scoped lang="scss" src="./style.scss"></style>

<script src="./script.js"></script>
